export const URL_ROOT = "root-url";
export const URL_404 = "error-404-url";
export const URL_LOGIN = "login-url";
export const URL_USER_SUBSCRIBE = "subsribe-user-url";
export const URL_CONFIRM_USER = "confirm-user-url";
export const URL_FORGOT_PASSWORD = "forgot-password-url";
export const URL_RESET_PASSWORD = "reset-password-url";
export const URL_USER_PROFILE_DETAIL = "detail-profile-url";
export const URL_PROFILE_EDIT = "profile-edit-url";
export const URL_ACCOUNT_SETTINGS = "account-settings-url";
export const URL_CREATE_AD = "create-ad-url";
export const URL_PREPARE_AD = "prepare-ad-url";
export const URL_LIST_AD = "list-ad-url";
export const URL_AD_DETAIL = "detail-ad-url";
export const URL_AD_ALERT_LIST = "list-alert-ad-url";
export const URL_AD_ALERT_ADD = "add-alert-ad-url";
export const URL_AD_ALERT_EDIT = "edit-alert-ad-url";
export const URL_AD_ALERT_DELETE = "delete-alert-ad-url";
export const URL_CREATE_CONVERSATION = "create-conversation-url";
export const URL_RESEND_CONFIRMATION_EMAIL = "resend-confirmation-email-url";
export const URL_AD_EDIT = "edit-ad-url";
export const URL_AD_TRANSFER = "transfer-ad-url";
export const URL_LIST_CONVERSATION = "list-conversation-url";
export const URL_CONVERSATION_DETAIL = "detail-conversation-url";
export const URL_CREATE_CONTRACT = "create-contract-url";
export const URL_CONTRACT_DETAIL = "detail-contract-url";
export const URL_CONTRACT_EDIT = "edit-contract-url";
export const URL_LANDING = "landing-page-url";
export const URL_SHARING_EQUIPMENT = "sharing-equipment-url";
export const URL_LOOKING_FOR_EQUIPMENT = "looking-for-equipment-url";
export const URL_ABOUT = "about-url";
export const URL_CONTACT = "contact-url";
export const URL_STRIPE_REFRESH = "stripe-refresh-link-url";
export const URL_STRIPE_VALIDATE = "stripe-validate-url";
export const URL_ADD_PAYMENT = "add-payment-url";
export const URL_PAYMENT_SUCCESS = "payment-success-url";
export const URL_PAYMENT_CANCEL = "payment-cancel-url";
export const URL_MANAGE_ADS = "manage-my-ads-url";
export const URL_LIST_USERS = "manage-users-url";
export const URL_CREATE_ADMIN = "create-admin-url";
export const URL_CREATE_USER = "create-user-url";
export const URL_CONFIRM_ADMIN = "confirm-admin-url";
export const URL_EDIT_PROFILE = "edit-user-profile-url";
export const URL_AD_ALERT_CONFIRM = "confirm-alert-ad-url";
export const URL_RATE = "rate";
